module.exports = __webpack_public_path__ + "static/media/sticky-note.cf1e13fc.png";